
import { useGuardsData } from "./hooks/useGuardsData";
import { GuardsList } from "./components/GuardsList";
import { GuardsHeader } from "./components/GuardsHeader";
import AppLayout from "@/components/layout/AppLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Archive } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Guards = () => {
  const { t } = useLanguage();
  const { 
    guards, 
    archivedGuards,
    teams, 
    isLoading, 
    isAdmin,
    isClient,
    refetchGuards, 
    handleTeamFilterChange,
    handleRoleFilterChange,
    selectedRole
  } = useGuardsData();

  return (
    <AppLayout>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20 relative overflow-hidden">
        {/* Enhanced background patterns */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/3 via-transparent to-blue-500/3 pointer-events-none"></div>
        <div className="absolute top-20 right-10 w-96 h-96 bg-gradient-radial from-blue-500/8 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-gradient-radial from-primary/8 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        <div className="relative z-10 space-y-8 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6 pb-12">
          <GuardsHeader onGuardAdded={refetchGuards} teams={teams} />
          
          <Tabs defaultValue="active" className="w-full">
            <TabsList className="mb-4">
              <TabsTrigger value="active" className="flex items-center gap-2">
                <Users className="h-4 w-4" />
                {t('activeUsers')} ({guards?.length || 0})
              </TabsTrigger>
              <TabsTrigger value="archived" className="flex items-center gap-2">
                <Archive className="h-4 w-4" />
                {t('archived')} ({archivedGuards?.length || 0})
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="active">
              <GuardsList
                guards={guards}
                teams={teams}
                isLoading={isLoading}
                onGuardRemoved={refetchGuards}
                isAdmin={isAdmin}
                isClient={isClient}
                onTeamFilterChange={handleTeamFilterChange}
                onRoleFilterChange={handleRoleFilterChange}
                selectedRole={selectedRole}
                showArchived={false}
              />
            </TabsContent>
            
            <TabsContent value="archived">
              <GuardsList
                guards={archivedGuards}
                teams={teams}
                isLoading={isLoading}
                onGuardRemoved={refetchGuards}
                isAdmin={isAdmin}
                isClient={isClient}
                onTeamFilterChange={handleTeamFilterChange}
                onRoleFilterChange={handleRoleFilterChange}
                selectedRole={selectedRole}
                showArchived={true}
              />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </AppLayout>
  );
};

export default Guards;
